import React, { memo, useContext, useEffect, useReducer } from 'react';
import './css/SleekCarouselGamesWidget1.css';
import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useSnackbar } from 'notistack';
import { context } from '../../../../globalState/GlobalState';
import { fetchLimitedPreviousGamesAPI, fetchLimitedScheduledGamesAPI } from '../../../apiCalls/games/GameAPICalls';
import GameWidget3 from '../gameWidget3/GameWidget3';
import Spinner2 from '../../spinners/spinner2/Spinner2';
import { getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';
import { isValidString } from '../../../../catalog/Validity';

const initialState = {
    previousGames: [],
    scheduledGames: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchPreviousGames':
            return { ...state, previousGames: action.games.reverse() };
        case 'fetchScheduledGames':
            return { ...state, scheduledGames: action.games };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}
function SleekCarouselGamesWidget1(props) {
    const { primaryBackgroundColor, smaller } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchGames() {
            await fetchLimitedScheduledGamesAPI(globalState.accountId, 10, setState, enqueueSnackbar);
            await fetchLimitedPreviousGamesAPI(globalState.accountId, 10, setState, enqueueSnackbar);
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
        }
        fetchGames();
    }, []);

    const styles = StyleSheet.create({
        container: {
            backgroundColor: primaryBackgroundColor && isValidString(globalState.websiteStyles.colors.primaryColor) ? globalState.websiteStyles.colors.primaryColor : '#FFFFFF',
        },
    });

    const isUpcomingGame = (timeOfGame) => {
        return getLocalTimeFromDatabaseTime(timeOfGame) > new Date();
    };

    const getGames = () => {
        return [...state.previousGames, ...state.scheduledGames];
    };

    const getInitialSlide = () => {
        if (state.previousGames.length <= 1) {
            return state.previousGames.length;
        }
        if (state.scheduledGames.length === 0) {
            return state.previousGames.length - 3;
        }
        return state.previousGames.length - 1;
    };

    const settings = {
        infinite: false,
        slidesToScroll: 1,
        variableWidth: true,
    };

    const initSlider = (ref) => {
        ref?.slickGoTo(getInitialSlide() || 0, true);
    };

    return (
        <div className={`sleek-carousel-games-widget1-container-container ${css(styles.container)}`} style={{ display: getGames().length === 0 && !state.loadingSpinner ? 'none' : 'flex', height: smaller ? '180px' : '250px' }}>
            {state.loadingSpinner ? (<Spinner2 color={primaryBackgroundColor ? globalState.websiteStyles.colors.fontColor : globalState.websiteStyles.colors.primaryColor} marginTop={10} size={100} />) : (
                <div className="sleek-carousel-games-widget1-container">
                    <Slider ref={initSlider} {...settings}>
                        {
                            getGames().map((game) => {
                                return (
                                    <GameWidget3 key={game.id} id={game.id} game={game} opponentName={game.opponentName} opponentLogo={game.opponentLogo} scheduled={isUpcomingGame(game.timeOfGame)} homeGame={game.homeGame} status={game.status} timeOfGame={game.timeOfGame} venue={game.venue} primaryBackgroundColor={primaryBackgroundColor} smaller={smaller} />
                                );
                            })
                        }
                    </Slider>
                </div>
            )}
        </div>
    );
}

SleekCarouselGamesWidget1.propTypes = {
    primaryBackgroundColor: PropTypes.bool,
    smaller: PropTypes.bool,
};

SleekCarouselGamesWidget1.defaultProps = {
    primaryBackgroundColor: false,
    smaller: false,
};

export default memo(SleekCarouselGamesWidget1);
